
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.75593 5.12713C5.35716 5.58759 4.64284 5.58759 4.24407 5.12713L1.23682 1.65465C0.675943 1.00701 1.136 9.13357e-08 1.99275 1.66235e-07L8.00725 6.9204e-07C8.864 7.6694e-07 9.32406 1.00701 8.76318 1.65465L5.75593 5.12713Z","fill":"#B1BFCA"}})])
          )
        }
      }
    